<template>
  <v-container>
    <h2>Update Request Helper Status</h2>
    <v-row>
      <v-col lg="10" md="12" sm="12">
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="status_name"
              label="Status name"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="updateStatus"
          >
            Update
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'request-helper-status-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "RequestHelperStatusEdit",
  data: () => ({
    status_id: 0,
    status_name: null
  }),
  async mounted () {
    this.status_id = this.$route.params.id
    await this.getRequestHelperStatus()
  },
  methods: {
    async getRequestHelperStatus () {
      try {
        const { data } = await this.$http.get(`/back-office/request-helper-status/${this.status_id}`, authHeader())
        this.status_name = data.status_name
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    async updateStatus () {
      try {
        if (this.requireField()) {
          await this.$http.put(`/back-office/request-helper-status/${this.status_id}`, { status_name: this.status_name }, authHeader())
          this.$router.push({ name: 'request-helper-status-list'})
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      if (!this.status_name) {
        alert('Please fill status name')
        return false;
      }
      return true
    }
  },
};
</script>
